export default "__VITE_ASSET__Cv_kyQt$__"